import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Button, TextInput, PasswordInput, EmailInput} from '../Presentation/Forms';
import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';
import Loader from '../Presentation/Loader';

import {registerAction} from '../../actions/Auth';
import {openRegisterSuccessPopup, openFailPopup} from '../../actions/Popup';

class RegisterPage extends React.Component {

    constructor(props) {
        super(props);
        this.register = this.register.bind(this);

        this.state = {
            emailError: null,
            nameError: null,
            passwordError: null,
            passwordRepError: null
        }
    }

    register(e) {
        e.preventDefault();
        const emailValid = this.refs.email.validate();
        const passValid = this.refs.pass.validate();
        const nameValid = this.refs.fullname.validate((val) => val.length >= 3, "Името ви трябва да е поне 3 символа");

        if (emailValid && passValid && nameValid) {
            let newState = {
                emailError: null,
                nameError: null,
                passwordError: null,
                passwordRepError: null
            };

            const {fullName, email, pass, passConfirm} = this.getInputValues();
            const referral = this.props.location.query.referral;

            if (pass !== passConfirm) {
                newState.passwordRepError = 'Паролите не съвпадат';
            }
            else {
                this.dispatchRegister(email, pass, fullName, referral)
            }

            this.setState(newState);
        }
    }

    dispatchRegister(email, pass, fullName, referral) {
        this.props.dispatch(registerAction(this.dispatchRegister.bind(this, email, pass, fullName, referral), {
            email: email,
            plainPassword: pass,
            fullname: fullName,
            referredBy: referral
        })).then(data => {
            this.props.dispatch(openRegisterSuccessPopup());
            return data;
        }).catch( (e) => {
            //TODO check for the type of error

            this.props.dispatch(openFailPopup({
                title: "Грешка",
                text: "Вече съществува акаунт използващ този имейл"
            }));
        });
    }

    getInputValues() {
        return {
            pass: this.refs.pass ? this.refs.pass.getValue() : "",
            passConfirm: this.refs.passconfirm ? this.refs.passconfirm.getValue() : "",
            fullName: this.refs.fullname ? this.refs.fullname.getValue() : "",
            email: this.refs.email ? this.refs.email.getValue() : ""
        }
    }

    render() {
        const {registerPending} = this.props;
        const {emailError, nameError, passwordError, passwordRepError} = this.state;
        const {fullName, email, pass, passConfirm} = this.getInputValues();

        return <FullWidthPage title="Регистрация">
            <form className="profile-form login" method="post">
                <Loader show={registerPending}/>
                <div className={registerPending ? "loading" : ""}>
                    <div className="col-md-8 col-md-offset-2">
                        <SectionTitle>Регистрация</SectionTitle>

                        <TextInput error={nameError} ref="fullname" value={fullName} id="fullname" name="fullname"
                                   required="required" label="Имена"/>
                        <EmailInput error={emailError} ref="email" value={email} id="email" name="email"
                                    required="required" label="Е-мейл Адрес"/>
                        <PasswordInput error={passwordError} ref="pass" value={pass} id="pass" name="pass"
                                       required="required" label="Парола"/>
                        <PasswordInput error={passwordRepError} ref="passconfirm" value={passConfirm} id="passconfirm"
                                       name="passconfirm" required="required" label="Повторете парола"/>

                        <div className="text-center">
                            <Button clickHandler={this.register} text="Регистрирай ме"/>
                        </div>

                        <div className="text-center">
                            <h4 className="section-separator-text">или</h4>
                            <div className="cta-text">Вече имате акаунт?</div>
                            <div>
                                <Link to="/login" className="btn btn-default">Вход</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {
        registerPending: state.auth.registerPending
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(RegisterPage);


// WEBPACK FOOTER //
// ./src/components/Pages/Register.js